import React, { useEffect, useState } from "react";
import { Typography, Tabs, Tab, Box, List, ListItem, ListItemText, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getTops, TopData } from "../../../services/hipodromo"; // Ajusta la ruta según tu estructura de archivos


interface Props {
  hipodromoId?: number;
}

const TopStatsMobile: React.FC<Props> = ({ hipodromoId = 1 }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [topData, setTopData] = useState<TopData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const fetchTops = async () => {
      try {
        setLoading(true); // Reset loading state on id change
        const data = await getTops(hipodromoId);
        setTopData(data);
      } catch (err) {
        setError("Error al cargar los datos");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTops();
  }, [hipodromoId]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const categories = ["Ejemplares", "Jinetes", "Preparadores"];
  const data = topData ? [topData.ejemplares, topData.jinetes, topData.preparadores] : [[], [], []];

  if (loading) {
    return <Typography>Cargando...</Typography>;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  const MobileView = () => (
    <Box sx={{ width: "100%", p: 2 }} id="tops-mobile-container">
      <Typography variant="h5" gutterBottom id="tops-title-mobile">
        🏆 Top del Año {currentYear}
      </Typography>
      <Tabs
        id="tops-mobile-tabs"
        value={tabIndex}
        onChange={handleTabChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        {categories.map((label, index) => (
          <Tab key={index} label={label} wrapped />
        ))}
      </Tabs>
      <List id="tops-mobile-list">
        {data[tabIndex].map((item, index) => (
          <Card key={index} className="my-2">
            <CardContent>
              <ListItem>
                <ListItemText
                  primary={item.nombre || "Sin nombre"}
                  secondary={`Victorias: ${item.victorias}`}
                />
              </ListItem>
            </CardContent>
          </Card>
        ))}
      </List>
    </Box>
  );

  const DesktopView = () => (
    <Box sx={{ width: "100%", p: 2 }} id="tops-desktop-container">
      <Typography variant="h5" gutterBottom id="tops-title-desktop">
        🏆 Top del Año {currentYear}
      </Typography>
      <TableContainer component={Paper} id="tops-desktop-table">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Posición</TableCell>
              <TableCell>Ejemplar</TableCell>
              <TableCell align="right">Victorias</TableCell>
              <TableCell>Jinete</TableCell>
              <TableCell align="right">Victorias</TableCell>
              <TableCell>Preparador</TableCell>
              <TableCell align="right">Victorias</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(Math.max(topData?.ejemplares.length || 0, topData?.jinetes.length || 0, topData?.preparadores.length || 0))].map((_, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell>{topData?.ejemplares[index]?.nombre || '-'}</TableCell>
                <TableCell align="right">{topData?.ejemplares[index]?.victorias || '-'}</TableCell>
                <TableCell>{topData?.jinetes[index]?.nombre || '-'}</TableCell>
                <TableCell align="right">{topData?.jinetes[index]?.victorias || '-'}</TableCell>
                <TableCell>{topData?.preparadores[index]?.nombre || '-'}</TableCell>
                <TableCell align="right">{topData?.preparadores[index]?.victorias || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  return isMobile ? <MobileView /> : <DesktopView />;
};

export default TopStatsMobile;